var amdi18n={"__root":{"message_text":"Do you want to save your Cloud Identity outside of your browser (for example, as a backup)?","download_cloud_identity":"Download Cloud Identity"},"__de":{"message_text":"Möchten Sie Ihre Cloud Identität außerhalb Ihres Browsers speichern (beispielsweise als Sicherung)?","download_cloud_identity":"Cloud Identität herunterladen"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;


//////////////////
// WEBPACK FOOTER
// ./node_modules/amdi18n-loader!./src/main/web/js/app/view/identity/nls/IdentityExportView_strings.js
// module id = 338
// module chunks = 1